import { render } from "./IncidentCompanySelect.vue?vue&type=template&id=0b22cd71"
import script from "./IncidentCompanySelect.vue?vue&type=script&lang=js"
export * from "./IncidentCompanySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__